
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"V1_00000057846019978028732050000010569497260145574843_"}},[_c('circle',{staticClass:"st0",attrs:{"cx":"33.3","cy":"7.9","r":"7.6"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"15.6","cy":"15.6","r":"6.9"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"8","cy":"33.2","r":"6.2"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"15.5","cy":"51","r":"5.7"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"33.3","cy":"58.6","r":"5.2"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"50.9","cy":"50.9","r":"4.5"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"58.5","cy":"33.2","r":"3.8"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"51","cy":"15.6","r":"3.2"}})])])
          )
        }
      }
    